export default {
  drawerVisible: true,
  drawerItems: [
    {
      title: 'Ausloggen',
      icon: 'arrow_back',
      path: '/logout',
    },
  ],
  snackbar: {
    text: '',
    color: '',
    timeout: 4000,
    show: false,
  },
  hiddenFields: {},
  auth: {
    hasDeleteRights: false,
  },
  currentUser: '',
  user: {},
};
